import { Injectable } from '@angular/core';
import {Http, Headers, Response, RequestOptions} from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import {current} from "codelyzer/util/syntaxKind";
import {UrlService} from "../Services/url.service";

@Injectable()
export class AuthenticationService {
  public token: string;
  url = this.URL.getLocal()+'/login';
  private headers = new Headers({'Content-Type':'application/json'});//parametrizamos a json
  private options = new RequestOptions({ headers: this.headers });

  constructor(private http: Http,private URL:UrlService) {
    // set token if saved in local storage
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
  }

  login(email: string, password: string): Observable<boolean> {
    let url = `${this.url}`;
    let users = JSON.stringify({ email: email, password: password });
    return this.http.post(url, users,this.options)
      .map((response: Response) => {
        // login successful if there's a jwt token in the response
        let token = response.json() && response.json().token;
        let role = response.json().role;
        let nombre = response.json().nombre;
        let fecha = response.json().fecha;
        if (token) {
          // set token property
          this.token = token;
          // store username and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify({ email: email, token: token}));
          localStorage.setItem('role', role);
          localStorage.setItem('usuario', nombre);
          localStorage.setItem('fecha', fecha);

          // return true to indicate successful login
          return true;
        } else {
          // return false to indicate failed login
          return false;
        }
      }).catch(this.handleError);
  }

  //Este metodo detecta un error en la llamada a http
  private handleError(error : Response | any) {
    let errMsj : string;
    if(error instanceof Response)
    {
      let body  = error.json() || '';
      let err = body.error || JSON.stringify(body);
      errMsj = `${error.status} - ${error.statusText || ''} ${err}`;
    }
    else
    {
      errMsj = error.message ? error.message : error.Tostring();
    }
    return Observable.throw(errMsj);
  }

  logout(): void {
    // clear token remove user from local storage to log user out
    this.token = null;
    localStorage.removeItem('currentUser');
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/Login/authentication.service.ts